import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../assets/images/logo.png';
import { loginUser } from "../Services/UserService";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate('/dashboard');
    }
    // Load remembered email
    const savedEmail = localStorage.getItem("rememberEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setLoading(true);

    const result = await loginUser(email, password);
    setLoading(false);

    if (!result.status) {
      setErrorMsg(result.message || 'Unauthorized Access');
      return;
    }

    localStorage.setItem("token", result.data.token);
    localStorage.setItem("userId", result.data.id);
    localStorage.setItem("userName", result.data.name);
    localStorage.setItem("userEmail", result.data.email);
    localStorage.setItem("userRole", result.data.role);

    window.dispatchEvent(new Event("auth-changed"));

    if (rememberMe) {
      localStorage.setItem("rememberEmail", email);
    } else {
      localStorage.removeItem("rememberEmail");
    }

    navigate("/dashboard");
  };

  return (
    <div className="login-wrapper">
      <div className="card p-4 shadow" style={{ width: '100%', maxWidth: '462px', minHeight: '500px', borderRadius: '20px' }}>
        <div className="text-center mb-4">
          <img src={logo} alt="Logo" className="img-fluid" style={{ maxHeight: '80px' }} />
        </div>

        <form onSubmit={handleLogin}>
          {errorMsg && (
            <div className="alert alert-danger p-2 text-center fs-6" role="alert">
              {errorMsg}
            </div>
          )}

          {/* Email */}
          <div className="mb-3 mt-3">
            <label htmlFor="email" className="form-label fs-6 fw-semibold">
              Enter Email
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Enter Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* Password */}
          <div className="mb-3 mt-4">
            <label htmlFor="password" className="form-label fs-6 fw-semibold">
              Enter Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          {/* Remember Me & Login Button */}
          <div className="d-flex justify-content-between align-items-center mb-3 mt-4">
            <div className="form-check custom-checkbox">
              <input
                className="form-check-input me-3"
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label className="form-check-label fs-5 fw-semibold mb-1" htmlFor="rememberMe">
                Remember Me
              </label>
            </div>

            <button type="submit" className="btn custom-login-btn" disabled={loading}>
              {loading ? 'Please wait...' : 'LOGIN'}
            </button>
          </div>

          {/* Forgot Password */}
          <div className="text-center">
            <button
              type="button"
              className="forgot-password-btn fs-5 fw-bold"
              onClick={() => navigate('/forgot-password')}
            >
              Forgot Password?
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;